import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';

interface Props {
  priceCut?: string;
  price?: string;
  classes?: {
    price?: string;
    priceCut?: string;
  };
  className?: string;
}

const Pricing: FC<Props> = ({ price, priceCut, classes, className }) => {
  return (
    <div className={twMerge(`flex gap-2 mb-4`, className)}>
      <p className='text-grayZl-500 text-base font-semibold self-start'>₹</p>
      <p
        className={twMerge(
          `text-white text-[32px] leading-[40px] font-semibold`,
          classes?.price,
        )}
      >
        {price}
      </p>
      <p
        className={twMerge(
          `line-through text-white/60 text-2xl font-medium self-end`,
          classes?.priceCut,
        )}
      >
        {priceCut}
      </p>
    </div>
  );
};

export default Pricing;
